import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sprout } from "lucide-react";

export function AuthImage({ path, alt = "", className = "", fallbackClassName = "" }) {
  const [src, setSrc] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let url = "";
    setFailed(false);
    setSrc("");
    if (!path) return;
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (revoked) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => setFailed(true));
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!path || failed) {
    return (
      <div className={`flex items-center justify-center bg-emerald-50 dark:bg-emerald-950/40 ${fallbackClassName || className}`}>
        <Sprout className="h-8 w-8 text-emerald-400" />
      </div>
    );
  }
  if (!src) {
    return <div className={`animate-pulse bg-stone-200 dark:bg-stone-800 ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
